export const INIT_BATTLE = '[BATTLE] INIT_BATTLE';
export const TURN_BATTLE = '[BATTLE] TURN_BATTLE';
export const WINNER = '[BATTLE] WINNER';
